import { render, staticRenderFns } from "./AiKnowledge.vue?vue&type=template&id=7d910bc6&scoped=true"
import script from "./AiKnowledge.vue?vue&type=script&lang=js"
export * from "./AiKnowledge.vue?vue&type=script&lang=js"
import style0 from "./AiKnowledge.vue?vue&type=style&index=0&id=7d910bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d910bc6",
  null
  
)

export default component.exports